import {Component, Input} from '@angular/core';
import {DatePipe, UpperCasePipe} from '@angular/common';
import {NzDescriptionsComponent, NzDescriptionsItemComponent} from 'ng-zorro-antd/descriptions';

@Component({
    selector: 'app-user-panel',
    imports: [
        DatePipe,
        NzDescriptionsComponent,
        NzDescriptionsItemComponent,
        UpperCasePipe
    ],
    template: `
    <nz-descriptions nzSize="small">
      <nz-descriptions-item nzSpan="3" nzTitle="UID">{{ user.uid }}</nz-descriptions-item>
      <nz-descriptions-item nzSpan="3" nzTitle="User Name">{{ user.name }}</nz-descriptions-item>
      <nz-descriptions-item nzSpan="3" nzTitle="Email">{{ user.email }}</nz-descriptions-item>
      <nz-descriptions-item nzSpan="3" nzTitle="Role">{{ user.role | uppercase }}</nz-descriptions-item>
      <nz-descriptions-item nzSpan="3" nzTitle="Halls">{{ user.halls }}</nz-descriptions-item>
      <nz-descriptions-item nzSpan="3" nzTitle="Session">{{ user.exp | date:'short' }}</nz-descriptions-item>
    </nz-descriptions>
  `,
    styles: ``
})
export class UserPanelComponent {

  @Input()
  user: any;
}
